/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

var SdxInputField = require('sdx/form/InputField').default;
var SdxTextarea = require('sdx/form/Textarea').default;

(function($, Tc) {
	/*
	 * Dependencies:
	 * TerrificJs 2.0.1,
	 * jQuery 1.7 or greater,
	 */

	'use strict';

	/**
	 * TextField module implementation.
	 *
	 * @author Nikola Tica
	 * @namespace Tc.Module
	 * @class TextField
	 * @extends Tc.Module
	 */
	Tc.Module.TextField = Tc.Module.extend({

		/**
		 * Hook function to do all of your module stuff.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {
			var mod = this,
				$ctx = this.$ctx;

			mod.$field = $('.field-input', $ctx);

			if ($ctx.is('.input-field--multiline')) {
				mod.sdxTextarea = new SdxTextarea($ctx[0]);
				mod.log('init textarea');
			} else {
				mod.sdxInputField = new SdxInputField(mod.$field[0]);
			}

			if (mod.$field.data('remember-last-entry')) {
				mod.localStorageItemId = mod.$field.data('remember-last-entry');
				mod.updateFieldValueFromLS();
				mod.$field.on('input', mod.saveEnteredValue.bind(mod));
			}

			if ($ctx.is('.mobile_number')) {
				mod.allowedNumberFieldInputs = /[\d+]/;
				mod.$field.on('keydown', mod.restrictNumberFieldInputs.bind(mod));
			} else if (mod.$field.data('number-field-to-restrict')) {
				mod.allowedNumberFieldInputs = /[\d-.]/;
				mod.$field.on('keydown', mod.restrictNumberFieldInputs.bind(mod));
			}

			if (mod.$field.data('display-length-constraint')) {
				mod.$textHolder = mod.$ctx.find('.input-text-length');
				mod.$field.on('input', mod.updateEnteredTextLengthHolder.bind(mod));
				mod.updateEnteredTextLengthHolder();
			}
			callback();
		},

		/**
		 * This function saves current field value to the localStorage.
		 *
		 * @method saveEnteredValue
		 * @return void
		 */
		saveEnteredValue: function() {
			var mod = this;

			var currentFieldVal = mod.$field.val();
			if (currentFieldVal !== '') {
				localStorage.setItem(mod.localStorageItemId, currentFieldVal);
				mod.log('saved ' + mod.localStorageItemId, currentFieldVal);
			}
		},

		/**
		 * This function sets the value from the local storage to the input element.
		 *
		 * @method updateFieldValueFromLS
		 * @return void
		 */
		updateFieldValueFromLS: function () {
			var mod = this;

			if(mod.$field) {
				var recordedValue = localStorage.getItem(mod.localStorageItemId);
				if (recordedValue) {
					mod.$field.val(recordedValue);
					if (mod.sdxTextarea && mod.sdxTextarea._updateHeight) {
						mod.sdxTextarea._updateHeight();
					}
					mod.log('recovered ' + mod.localStorageItemId, recordedValue);
				}
			}
		},

		/**
		 * This function is used to prevent entering values other than Numbers,
		 * '-' or '.' into number type input field.
		 *
		 * @method restrictNumberFieldInputs
		 * @param {Event} evt
		 * @return Boolean
		 */
		restrictNumberFieldInputs : function (evt) {
			var mod = this,
				enteredValue = evt.key;
			//IE11/ MSEdge workaround for NumPad '+', '*', '/', and Space Bar
			if(['add', 'divide', 'multiply', 'spacebar'].indexOf(enteredValue.toLowerCase()) !== -1) {
				return false;
			}
			return !(enteredValue.length === 1 && !mod.allowedNumberFieldInputs.test(enteredValue));
		},

		/**
		 * This functions displays input field text length number.
		 *
		 * @method updateEnteredTextLengthHolder
		 * @return Boolean
		 */
		updateEnteredTextLengthHolder : function () {
			var mod = this;
			var textLength = mod.$field.val().length;

			mod.$textHolder.text(textLength);
		}
	});
}(window.Tc.$, window.Tc));

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/forms/clientlibs/shared/js/modules/Tc.Module.TextField.js
// module id = 283
// module chunks = 0